/* eslint-disable no-empty,no-param-reassign,@typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerLimitComponent', [
    '$timeout',
    'DesignerComponent',
    'DesignerSchema',

    function ($timeout, DesignerComponent, DesignerSchema) {
      function DesignerLimitComponent() {
        DesignerComponent.apply(this);

        this.partitioning = null;
        this.order = null;
        this.n = null;
        this.partitioned_fields = [];
        this.ordered_fields = [];
      }

      DesignerLimitComponent.prototype = new DesignerComponent();

      DesignerLimitComponent.prototype.getFormData = function () {
        const data = {};
        const baseData = DesignerComponent.prototype.getData.call(this);
        const formData = DesignerComponent.prototype.getFormData.call(this);
        const componentData = this.getData();

        _.extend(data, baseData);
        _.extend(data, formData);
        _.extend(data, componentData);

        this.partitioning = data.partitioned_fields.length > 0 ? 'partition_by' : 'all';
        this.order = data.ordered_fields.length > 0 ? 'sort' : 'no_sort';

        _.extend(data, {
          partitioning: this.partitioning,
          order: this.order,
        });

        return data;
      };

      DesignerLimitComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.extend(data, {
          n: this.n || 1,
          partitioned_fields: this.partitioned_fields || [],
          ordered_fields: this.ordered_fields || [],
        });

        return data;
      };

      DesignerLimitComponent.prototype.setFormData = function (data) {
        this.partitioning = data.partitioning;
        this.order = data.order;

        this.setData(data);

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerLimitComponent.prototype.setData = function (data) {
        try {
          data.n = Number(data.n);
        } catch (e) {}

        this.n = data.n;
        this.partitioned_fields = data.partitioned_fields;
        if (data.order === 'no_sort') {
          this.ordered_fields = [];
        } else {
          this.ordered_fields = data.ordered_fields;
        }

        DesignerComponent.prototype.setData.call(this, data);
      };

      DesignerLimitComponent.prototype.getSchema = function () {
        const schema = DesignerComponent.prototype.getSchema.call(this);

        return schema;
      };

      return DesignerLimitComponent;
    },
  ]);
})(window.angular);
